import { Link } from '@material-ui/core'
import Backdrop from '@material-ui/core/Backdrop'
import CircularProgress from '@material-ui/core/CircularProgress'
import { createTheme, MuiThemeProvider } from '@material-ui/core/styles'
import Button from '@mui/material/Button'
import MUIDataTable from "mui-datatables"
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useQuery } from 'react-query'
import { useAuth } from '../../hooks/auth'
import MvmApi from '../../services/MvmApi'
import { useStyles } from './Style'

type Props = {
    reloadOnCLick?: any;
    getCounts?: any;
}

const ResubmissionRequisition: React.FC<Props> = (props) => {
    const classes = useStyles();
    const { t: _t } = useTranslation("General");
    const { t } = useTranslation("EntryPlant");
    const { user } = useAuth();
    const [openBackdrop] = React.useState(false);
    const { isLoading, isFetching, data, refetch } = useQuery('resubmissionRequisitionList', async () => {
        props.getCounts();
        return await MvmApi.getResubmissionRequisitionList(+user.company.plantID);
    }, {
        staleTime: 1000 * 360, //calculado em milisegundos - Propriedade para setar qto tempo o cache fica válido
        refetchInterval: 1000 * 1200, //calculado em milisegundos - Propriedade para setar qto tempo vai buscar o cache novamente
        refetchOnWindowFocus: false,
        refetchIntervalInBackground: true,
    });

    useEffect(() => {
        refetch();
    }, []);

    useEffect(() => {
        if (props.reloadOnCLick > 0) {
            refetch();
        }
    }, [props.reloadOnCLick]);

    const columns = [
        {
            name: 'mvmNumber',
            label: t("mvmCode"),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                }),
                setCellProps: () => ({
                    align: "center"
                })
            }

        },
        {
            name: 'shedCode',
            label: t("shedCode"),
        },
        {
            name: 'requestNumber',
            label: t("requestNumber"),
        },
        {
            name: 'invoiceKey',
            label: t("invoiceNumber"),
        },
        {
            name: 'incomingInvoiceKey',
            label: t("invoiceEntryNumber"),
        },
        {
            style: { width: 80 },
            name: 'id',
            label: ' ',
            innerWidth: 10,
            options: {
                customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
                    return (
                        <Link href={`/SubmitOutgoingInvoiceRequest/${value}`} underline="none">
                            <Button style={{ height: "100%", width: "90%", fontSize: "0.7rem", padding: "2px" }} variant="outlined">
                                Gerar nova requisição
                            </Button>
                        </Link>
                    )
                }
            },
        },
    ]

    const options = {
        textLabels: {
            body: {
                noMatch: _t('noMatch'),
                toolTip: "",
            },
            pagination: {
                next: _t("next"),
                previous: _t("previous"),
                rowsPerPage: _t("rowsPerPage") + ":",
                displayRows: _t("of"),
            }
        }
    }

    const myTheme = createTheme({
        overrides: {
            MuiTableBody: {
                root: {
                    cursor: ''
                }
            },
            MuiTableCell: {
                root: {
                    paddingLeft: 4,
                    paddingRight: 4,
                    paddingBottom: 10,
                    paddingTop: 10
                },
                head: {
                    height: 52
                }
            }
        }
    })

    return (
        <>
            <Backdrop className={classes.backdrop} open={openBackdrop || isLoading || isFetching}>
                <CircularProgress color="inherit" />
            </Backdrop>

            {
                <MuiThemeProvider theme={myTheme}>
                    <MUIDataTable
                        title=""
                        data={data != null && data.length > 0 ? data : []}
                        columns={columns}
                        options={{
                            ...options,
                            serverSide: true,
                            pagination: false,
                            sort: false,
                            selectToolbarPlacement: "none",
                            filter: false,
                            search: false,
                            download: false,
                            print: false,
                            viewColumns: false,
                            selectableRows: 'none',
                        }}
                    />
                </MuiThemeProvider>
            }
        </>
    )
}
export default ResubmissionRequisition;
